import { PaymentStatus, PaymentMethod } from '../state/types/payments';

export const en = {
  payments: {
    pageTitle: 'Platform » Payments',
    generalFeedback: {
      success: 'Payment completed successfully',
      error: 'Something went wrong, please try again.',
      confirmFeedback: {
        logged: 'Return to Home',
        notLogged: 'Go to Login',
      },
    },
    pay: 'Pay',
    recharge: 'Top up',
    table: {
      tableTitle: 'Payments history',
      name: 'Payment name',
      executionDate: 'Execution date',
      transactionAmount: 'Payment amount',
      status: {
        label: 'Payment status',
        [PaymentStatus.PAID]: 'Paid',
        [PaymentStatus.PARTIALLY_PAID]: 'Partially paid',
        [PaymentStatus.REFUNDED]: 'Refunded',
        [PaymentStatus.CANCELED]: 'Canceled',
        [PaymentStatus.UNKNOWN]: 'Unknown',
        [PaymentStatus.PENDING]: 'To be paid',
        [PaymentStatus.FAILED]: 'Failed',
      },
    },
    filter: {
      title: 'Filters',
      dateRange: 'Date range',
      fromDate: 'From',
      toDate: 'To',
      amountRange: 'Amount range',
      fromAmount: 'From',
      toAmount: 'To',
      statusPlaceholder: {
        label: 'Payment status',
        placeholder: 'Select a status',
        [PaymentStatus.PAID]: 'Paid',
        [PaymentStatus.PARTIALLY_PAID]: 'Partially paid',
        [PaymentStatus.REFUNDED]: 'Refunded',
        [PaymentStatus.CANCELED]: 'Canceled',
        [PaymentStatus.UNKNOWN]: 'Unknown',
        [PaymentStatus.PENDING]: 'To be paid',
        [PaymentStatus.FAILED]: 'Failed',
      },
      close: 'Close',
      filter: 'Filter',
      reset: 'Reset filters',
    },
    noPaymentsFound: {
      title: 'Payments history',
      description: 'No payments have been made yet',
    },
    detail: {
      title: 'Payment details',
      paymentId: 'Payment ID',
      paymentStatus: {
        label: 'Payment status',
        [PaymentStatus.PAID]: 'Paid',
        [PaymentStatus.PARTIALLY_PAID]: 'Partially paid',
        [PaymentStatus.REFUNDED]: 'Refunded',
        [PaymentStatus.CANCELED]: 'Canceled',
        [PaymentStatus.UNKNOWN]: 'Unknown',
        [PaymentStatus.PENDING]: 'To be paid',
        [PaymentStatus.FAILED]: 'Failed',
      },
      paymentDate: 'Execution date',
      paymentMethod: {
        label: 'Payment type',
        [PaymentMethod.BANK_TRANSFER]: 'Bank transfer',
        [PaymentMethod.CREDIT_CARD]: 'Credit card',
      },
      transactionName: 'Transaction name',
      transactionAmount: 'Amount',
      organizationName: 'Organization name',
      productName: 'Product name',
      bankInfo: {
        iban: 'IBAN',
        bic: 'BIC',
        accountHolderName: 'Account holder name',
        country: 'Country',
      },
      copyToClipboard: 'Copy to clipboard',
      copiedToClipboard: 'Copied to clipboard',
    },
    pendingPaymentsList: {
      title: 'Installments to be paid',
      showDetails: 'Show details',
    },
  },
};
